import { jsx as _jsx } from "react/jsx-runtime";
import { Col, Row } from "antd";
import { contentMaxWidth } from "./SharedLayout";
export const StandardWidth = ({ children, noPad = false, }) => (_jsx(Row, { style: {
        padding: noPad ? 0 : "1rem",
        maxWidth: contentMaxWidth,
        margin: "0 auto",
    }, children: _jsx(Col, { flex: 1, children: children }) }));
//# sourceMappingURL=StandardWidth.js.map